import { render, staticRenderFns } from "./TheHeaderAvatar.vue?vue&type=template&id=668f1344"
import script from "./TheHeaderAvatar.vue?vue&type=script&lang=js"
export * from "./TheHeaderAvatar.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderAvatar.vue?vue&type=style&index=0&id=668f1344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports